import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import Label from "components/general/Label"
import { getSportCodeEntityObjects } from 'components/common/SportCode'
import KikScoreboard from "components/sports/kik/views/KikScoreboard";
import Referees from 'components/general/Referees'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import KikContact from "components/sports/kik/views/KikContact";
import KikPointFight from "components/sports/kik/views/KikPointFight";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const KikContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const queryClient = useQueryClient();
    const [periodsOrder, setPeriodsOrder] = useState()
    useEffect(() => {
        const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
        const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
        const periodsOrder_ = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];
        setPeriodsOrder(periodsOrder_)
    }, [])

    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading && !periodsOrder) { return <Loader />; }
    if (!data?.results) { return <NotAvailable /> }

    let lightContact = mirs_rsc.includes('LC')
    let fullContact = mirs_rsc.includes('FC')
    let pointFight = mirs_rsc.includes('PF')

    const resultStatus = data?.results?.status?.code;
    let bodyMiddle
    let score

    bodyMiddle = <KikScoreboard data={data} status={resultStatus} mirs_discipline={mirs_discipline} />

    score = <ScoreHorizontal
        data={data}
        scoreBody={{
            top: <></>,
            middle: <>{bodyMiddle}</>
        }}
    />

    return (
        <>
            <PageHeader data={data} />
            <div className='mirs-page-container'>
            <div className='my-5'>
                {score}
            </div>
            {data?.results && (lightContact || fullContact)
                ? <KikContact data={data} />
                : data?.results && pointFight
                    ? <KikPointFight data={data} />
                    : ''
            }
            {data?.results?.officials &&
                <Referees data={data?.results?.officials} showHeader={<Label data="HeaderFunction"/>}/>
            }
            </div>
        </>
    )

}

export default KikContext;